import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentStep: 0,
    prevStep: null,
    pathway: null,
    results: [],
    resultValue: null,
  },
  mutations: {
    setCurrentStep(state, payload) {
      state.currentStep = payload;
    },
    setPrevStep(state, payload) {
      state.prevStep = payload;
    },
    setResultValue(state, payload) {
      state.resultValue = payload;
    },
    setPathway(state, payload) {
      console.log({payload});
      state.pathway = payload;
    },
    setResult(state, payload) {
      console.log({payload});
      state.results = [...state.results, payload ]
    },
    resetResults(state, payload) {
      state.results = [];
    },
    updateResult(state, payload) {
      const updatedResultIndex = state.results.findIndex(result => result.key == payload.key);
      const updatedResults = [...state.results];
      updatedResults[updatedResultIndex] = payload;

      // trim array to new length, ending with the updated one.
      state.results = updatedResults.slice(0, updatedResultIndex + 1);
    }
  },
  actions: {
  },
})
